import React from 'react';
import { EditSingleFieldForm } from './EditSingleFieldForm';
import { eEditSingleFieldInputType } from './eEditSingleFieldInputType';

export interface IEditSingleFieldControllerProps<T> {
  actions: {
    onClose: () => void;
    doSubmit: (x: T) => Promise<{ message: string }>;
  };
  displayLabel: string;
  value: T;
  validationSchema: any;
  inputType: eEditSingleFieldInputType;
}

export const EditSingleFieldController = <T extends any>(props: IEditSingleFieldControllerProps<T>) => {
  return <EditSingleFieldForm {...props} />;
};
